import { TextFormatUnderline16 } from 'ui/icons/aurora/16px/TextFormatUnderline16';
import { useFormattingContext } from '../contexts/formatting';
import { BaseToolbarButton } from './BaseToolbarButton';
import { useTranslation } from '../../../../../hooks/useTranslation';

export const ToggleUnderlineButton = () => {
  const { isUnderlineEnabled, toggleUnderline } = useFormattingContext();
  const { t } = useTranslation();
  return (
    <BaseToolbarButton
      isSelected={isUnderlineEnabled}
      onClick={toggleUnderline}
      tooltip={t('contentPicker.textEditor.underline')}
      data-test="underline-button"
    >
      <TextFormatUnderline16 isColorInherited />
    </BaseToolbarButton>
  );
};
